import {Injectable} from '@angular/core';
import {WindowReferenceService} from './window-reference.service';
import {Router} from "@angular/router";
import {SessionStorage} from "ngx-webstorage";
import {Project} from "../../project/shared/project-model";
import {User} from "../user/user";

@Injectable({
  providedIn: 'root'
})

export class CtaClickEventDatalayerService {
  private window;

  @SessionStorage() currentProject: Project;
  @SessionStorage() user: User;

  constructor(private windowRef: WindowReferenceService, private router: Router) {
    this.window = windowRef.nativeWindow;
  }

  private DataLayerTrigger(ctaClickEvent) {
    if (ctaClickEvent) {
      this.window.dataLayer.push(ctaClickEvent);
    }
  }

  CtaClickEvent(eventName: string, configuration_id: string, configuration_name: string) {

    if (eventName === 'Add Configuration') {
      configuration_name = configuration_name.slice(2, -3);
    }

    let event = {
      event: 'cta_click',
      configurator_id: 46676,
      configurator_name: 'EcoStruxure PowerBuild Contractors',
      cta_location: (eventName !== "Add Configuration") ? this.router.url.replace('/', '') : "projects",
      cta_name: eventName,
      cta_link: this.router.url,
      configuration_id: (configuration_id) ? configuration_id : '',
      configuration_name: (configuration_name) ? configuration_name : '',
      project_id: this.currentProject?.id,
      project_name: this.currentProject?.name,
      user_id: this.user.id
    }
    this.DataLayerTrigger(event);
  }
}
